import React, {
 useContext, useState
} from 'react';
import {
  Dialog,
  DialogContent,
} from 'shared/components/ui/dialog';
import {
 Context
} from 'shared/context/GlobalState';
import {
 channelService
} from 'shared/api';
import WhatsAppSetup from './WhatsAppSetup';
import type {
 Channel, RedisChannelAdd
} from '../../types/builderChannel.types';

interface WhatsAppUpdateProps {
  isOpen: boolean;
  setOpenWhatsAppModal: (open: boolean) => void;
  channel: Channel;
  setEmailChannels: React.Dispatch<React.SetStateAction<Channel[]>>;
}

export default function WhatsAppUpdate({
  isOpen,
  setOpenWhatsAppModal,
  channel,
  setEmailChannels
}: WhatsAppUpdateProps) {
  const {
 addNewNotifcation
} = useContext(Context);

const [newChannelObj, setNewChannelObj] = useState<RedisChannelAdd | Channel>(channel);

const handleOnSubmit = async (channelObj: Channel | RedisChannelAdd) => {
  // Server update schema is strict: address/type/provider are immutable. The
  // assistant is rebindable — the server resolves the new assistant and swaps
  // assistant_id + assistant_token together. Listener channels additionally own
  // their KB collection and source filter — the server accepts those three fields
  // for listeners only, so they are sent only when set.
  const c = channelObj as Channel;
  // The sidebar writes the selection as `assistantId` (camelCase); the stored
  // record carries `assistant_id`.
  const assistantId = (channelObj as any).assistantId ?? c.assistant_id;
  const channelObj1 = {
    org_id: channelObj.org_id,
    sub_org_id: channelObj.sub_org_id,
    channelId: channelObj._id || '',
    topic: channelObj.topic,
    receive_enabled: c.receive_enabled,
    send_mode: c.send_mode,
    ...(assistantId ? { assistant_id: assistantId } : {}),
    ...(c.collectionId ? { collectionId: c.collectionId } : {}),
    ...(c.receive_filter ? { receive_filter: c.receive_filter } : {}),
    ...(Array.isArray(c.receive_sources) ? { receive_sources: c.receive_sources } : {}),
    // Co-existence only. The server rejects phone_number_id on any other provider
    // with a 400, which would take the whole update down — so it is sent only when
    // this really is a co-existence channel and a value is set.
    ...(c.provider === 'coexistence' && c.phone_number_id
      ? { phone_number_id: c.phone_number_id }
      : {}),
  };

  try {
    await channelService.updateChannel(channelObj1);

    setEmailChannels((prev) =>
      prev.map((item) =>
        item._id === channelObj._id
          ? {
          ...item,
          ...channelObj
          } as Channel
          : item
      )
    );

    addNewNotifcation('Channel Updated successfully', 'success');
    setOpenWhatsAppModal(false);
  } catch (error: any) {

    if (error.response?.status === 404) {
      addNewNotifcation('Channel not found', 'danger');
    } else {
      addNewNotifcation('Something went wrong', 'danger');
    }
  }
};

  return (
      <Dialog open={isOpen} onOpenChange={setOpenWhatsAppModal}>
          <DialogContent className="p-0 sm:max-w-[920px] max-w-none overflow-y-auto max-h-[95svh] sm:max-h-[95vh]">
              <WhatsAppSetup
          newChannelObj={newChannelObj}
          setNewChannelObj={setNewChannelObj}
          isUpdate={true}
          onSubmit={handleOnSubmit}
          setOpenEmailModal={setOpenWhatsAppModal}
        />
          </DialogContent>
      </Dialog>
  );
}
